import { useEffect, useRef } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useAppStore } from '@/stores/appStore';

/**
 * Layout wrapper for `/tenant/:tenantId/...` routes.
 * Extracts tenantId from the URL and syncs it to the app store.
 * Renders child routes via <Outlet />.
 */
export const TenantLayout = () => {
  const { tenantId } = useParams<{ tenantId: string }>();
  const setSelectedTenant = useAppStore((s) => s.setSelectedTenant);
  const prevTenantRef = useRef<string | undefined>();

  useEffect(() => {
    if (tenantId && tenantId !== prevTenantRef.current) {
      prevTenantRef.current = tenantId;
      setSelectedTenant(tenantId);
    }
  }, [tenantId, setSelectedTenant]);

  return <Outlet />;
};
